export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">关于桃子视频</h2>
        <div className="w-16 h-1 bg-primary-400 mx-auto mb-8 rounded-full"></div>
        <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 max-w-3xl mx-auto">
          <p>
            桃子视频创立于对优质影视内容的热爱，致力于为广大影迷打造一个按情感色彩分类的独特观影平台。
            我们将影视作品按情感调性划分为<strong>红桃、黑桃、桃花、红杏、糖心、豆花、粉桃、白桃、紫桃、蓝桃</strong>等主题频道，
            让每一位观众都能根据自己的心情快速找到想看的内容。
          </p>
          <p>
            平台收录超过十万部高清电影、电视剧、综艺、动漫和纪录片资源，涵盖国内外最新热门与经典佳作。
            桃子视频坚持<strong>免费观影、高清流畅、全端适配</strong>三大原则，采用全球CDN加速与智能线路切换技术，
            确保在任何网络环境下都能获得流畅的观影体验。从温情治愈到悬疑烧脑，从搞笑综艺到深度纪实，
            桃子视频用色彩点亮你的每一次观影时光。
          </p>
        </div>
      </div>
    </section>
  );
}